/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgClipboardCheckmark = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M6 2h10v2h4v10h-2V6h-2v2H6V6H4v14h9v2H2V4h4zm2 2v2h6V4z" />
        <path d="m21 15.318 1.462 1.364-5.398 5.784L14 19.182l1.462-1.364 1.602 1.716z" />
      </g>
    </g>
  </Icon>
);
export { SvgClipboardCheckmark as ClipboardCheckmark };
